export type Country = {
  readonly id: string;
  readonly englishName: string;
};

export const NOVAPOST_PRESENCE_COUNTRY_CODES: ReadonlyArray<string> = Object.freeze([
  'UA',
  'PL',
  'DE',
  'LT',
  'LV',
  'HU',
  'MD',
  'RO',
  'SK',
  'CZ',
  'EE',
]);

export const UKRPOSHTA_COUNTRIES: ReadonlyArray<Country> = Object.freeze([
  { id: 'AD', englishName: 'Andorra' },
  { id: 'AE', englishName: 'United Arab Emirates' },
  { id: 'AF', englishName: 'Afghanistan' },
  { id: 'AG', englishName: 'Antigua and Barbuda' },
  { id: 'AI', englishName: 'Anguilla' },
  { id: 'AL', englishName: 'Albania' },
  { id: 'AM', englishName: 'Armenia' },
  { id: 'AO', englishName: 'Angola' },
  { id: 'AQ', englishName: 'Antarctica' },
  { id: 'AR', englishName: 'Argentina' },
  { id: 'AS', englishName: 'American Samoa' },
  { id: 'AT', englishName: 'Austria' },
  { id: 'AU', englishName: 'Australia' },
  { id: 'AW', englishName: 'Aruba' },
  { id: 'AZ', englishName: 'Azerbaijan' },
  { id: 'BA', englishName: 'Bosnia and Herzegovina' },
  { id: 'BB', englishName: 'Barbados' },
  { id: 'BD', englishName: 'Bangladesh' },
  { id: 'BE', englishName: 'Belgium' },
  { id: 'BF', englishName: 'Burkina Faso' },
  { id: 'BG', englishName: 'Bulgaria' },
  { id: 'BH', englishName: 'Bahrain' },
  { id: 'BI', englishName: 'Burundi' },
  { id: 'BJ', englishName: 'Benin' },
  { id: 'BM', englishName: 'Bermuda' },
  { id: 'BN', englishName: 'Brunei Darussalam' },
  { id: 'BO', englishName: 'Bolivia, Plurinational State of' },
  { id: 'BQ', englishName: 'Bonaire, Sint Eustatius and Saba' },
  { id: 'BR', englishName: 'Brazil' },
  { id: 'BS', englishName: 'Bahamas' },
  { id: 'BT', englishName: 'Bhutan' },
  { id: 'BW', englishName: 'Botswana' },
  { id: 'BY', englishName: 'Belarus' },
  { id: 'BZ', englishName: 'Belize' },
  { id: 'CA', englishName: 'Canada' },
  { id: 'CC', englishName: 'Cocos (Keeling) Islands' },
  { id: 'CD', englishName: 'Congo, Democratic Republic of the' },
  { id: 'CF', englishName: 'Central African Republic' },
  { id: 'CG', englishName: 'Congo' },
  { id: 'CH', englishName: 'Switzerland' },
  { id: 'CI', englishName: "Côte d'Ivoire" },
  { id: 'CK', englishName: 'Cook Islands' },
  { id: 'CL', englishName: 'Chile' },
  { id: 'CM', englishName: 'Cameroon' },
  { id: 'CN', englishName: 'China' },
  { id: 'CO', englishName: 'Colombia' },
  { id: 'CR', englishName: 'Costa Rica' },
  { id: 'CU', englishName: 'Cuba' },
  { id: 'CV', englishName: 'Cabo Verde' },
  { id: 'CW', englishName: 'Curaçao' },
  { id: 'CX', englishName: 'Christmas Island' },
  { id: 'CY', englishName: 'Cyprus' },
  { id: 'CZ', englishName: 'Czechia' },
  { id: 'DE', englishName: 'Germany' },
  { id: 'DJ', englishName: 'Djibouti' },
  { id: 'DK', englishName: 'Denmark' },
  { id: 'DM', englishName: 'Dominica' },
  { id: 'DO', englishName: 'Dominican Republic' },
  { id: 'DZ', englishName: 'Algeria' },
  { id: 'EC', englishName: 'Ecuador' },
  { id: 'EE', englishName: 'Estonia' },
  { id: 'EG', englishName: 'Egypt' },
  { id: 'EH', englishName: 'Western Sahara' },
  { id: 'ER', englishName: 'Eritrea' },
  { id: 'ES', englishName: 'Spain' },
  { id: 'ET', englishName: 'Ethiopia' },
  { id: 'FI', englishName: 'Finland' },
  { id: 'FJ', englishName: 'Fiji' },
  { id: 'FK', englishName: 'Falkland Islands (Malvinas)' },
  { id: 'FM', englishName: 'Micronesia, Federated States of' },
  { id: 'FO', englishName: 'Faroe Islands' },
  { id: 'FR', englishName: 'France' },
  { id: 'GA', englishName: 'Gabon' },
  { id: 'GB', englishName: 'United Kingdom of Great Britain and Northern Ireland' },
  { id: 'GD', englishName: 'Grenada' },
  { id: 'GE', englishName: 'Georgia' },
  { id: 'GF', englishName: 'French Guiana' },
  { id: 'GH', englishName: 'Ghana' },
  { id: 'GI', englishName: 'Gibraltar' },
  { id: 'GL', englishName: 'Greenland' },
  { id: 'GM', englishName: 'Gambia' },
  { id: 'GN', englishName: 'Guinea' },
  { id: 'GP', englishName: 'Guadeloupe' },
  { id: 'GQ', englishName: 'Equatorial Guinea' },
  { id: 'GR', englishName: 'Greece' },
  { id: 'GT', englishName: 'Guatemala' },
  { id: 'GU', englishName: 'Guam' },
  { id: 'GW', englishName: 'Guinea-Bissau' },
  { id: 'GY', englishName: 'Guyana' },
  { id: 'HK', englishName: 'Hong Kong' },
  { id: 'HN', englishName: 'Honduras' },
  { id: 'HR', englishName: 'Croatia' },
  { id: 'HT', englishName: 'Haiti' },
  { id: 'HU', englishName: 'Hungary' },
  { id: 'ID', englishName: 'Indonesia' },
  { id: 'IE', englishName: 'Ireland' },
  { id: 'IL', englishName: 'Israel' },
  { id: 'IN', englishName: 'India' },
  { id: 'IO', englishName: 'British Indian Ocean Territory' },
  { id: 'IQ', englishName: 'Iraq' },
  { id: 'IR', englishName: 'Iran, Islamic Republic of' },
  { id: 'IS', englishName: 'Iceland' },
  { id: 'IT', englishName: 'Italy' },
  { id: 'JM', englishName: 'Jamaica' },
  { id: 'JO', englishName: 'Jordan' },
  { id: 'JP', englishName: 'Japan' },
  { id: 'KE', englishName: 'Kenya' },
  { id: 'KG', englishName: 'Kyrgyzstan' },
  { id: 'KH', englishName: 'Cambodia' },
  { id: 'KI', englishName: 'Kiribati' },
  { id: 'KM', englishName: 'Comoros' },
  { id: 'KN', englishName: 'Saint Kitts and Nevis' },
  { id: 'KR', englishName: 'Korea, Republic of' },
  { id: 'KW', englishName: 'Kuwait' },
  { id: 'KY', englishName: 'Cayman Islands' },
  { id: 'KZ', englishName: 'Kazakhstan' },
  { id: 'LA', englishName: "Lao People's Democratic Republic" },
  { id: 'LB', englishName: 'Lebanon' },
  { id: 'LC', englishName: 'Saint Lucia' },
  { id: 'LI', englishName: 'Liechtenstein' },
  { id: 'LK', englishName: 'Sri Lanka' },
  { id: 'LR', englishName: 'Liberia' },
  { id: 'LS', englishName: 'Lesotho' },
  { id: 'LT', englishName: 'Lithuania' },
  { id: 'LU', englishName: 'Luxembourg' },
  { id: 'LV', englishName: 'Latvia' },
  { id: 'LY', englishName: 'Libya' },
  { id: 'MA', englishName: 'Morocco' },
  { id: 'MC', englishName: 'Monaco' },
  { id: 'MD', englishName: 'Moldova, Republic of' },
  { id: 'ME', englishName: 'Montenegro' },
  { id: 'MG', englishName: 'Madagascar' },
  { id: 'MH', englishName: 'Marshall Islands' },
  { id: 'MK', englishName: 'North Macedonia' },
  { id: 'ML', englishName: 'Mali' },
  { id: 'MN', englishName: 'Mongolia' },
  { id: 'MO', englishName: 'Macao' },
  { id: 'MP', englishName: 'Northern Mariana Islands' },
  { id: 'MQ', englishName: 'Martinique' },
  { id: 'MR', englishName: 'Mauritania' },
  { id: 'MS', englishName: 'Montserrat' },
  { id: 'MT', englishName: 'Malta' },
  { id: 'MU', englishName: 'Mauritius' },
  { id: 'MV', englishName: 'Maldives' },
  { id: 'MW', englishName: 'Malawi' },
  { id: 'MX', englishName: 'Mexico' },
  { id: 'MY', englishName: 'Malaysia' },
  { id: 'MZ', englishName: 'Mozambique' },
  { id: 'NA', englishName: 'Namibia' },
  { id: 'NC', englishName: 'New Caledonia' },
  { id: 'NE', englishName: 'Niger' },
  { id: 'NF', englishName: 'Norfolk Island' },
  { id: 'NG', englishName: 'Nigeria' },
  { id: 'NI', englishName: 'Nicaragua' },
  { id: 'NL', englishName: 'Netherlands, Kingdom of the' },
  { id: 'NO', englishName: 'Norway' },
  { id: 'NP', englishName: 'Nepal' },
  { id: 'NR', englishName: 'Nauru' },
  { id: 'NU', englishName: 'Niue' },
  { id: 'NZ', englishName: 'New Zealand' },
  { id: 'OM', englishName: 'Oman' },
  { id: 'PA', englishName: 'Panama' },
  { id: 'PE', englishName: 'Peru' },
  { id: 'PF', englishName: 'French Polynesia' },
  { id: 'PG', englishName: 'Papua New Guinea' },
  { id: 'PH', englishName: 'Philippines' },
  { id: 'PK', englishName: 'Pakistan' },
  { id: 'PL', englishName: 'Poland' },
  { id: 'PM', englishName: 'Saint Pierre and Miquelon' },
  { id: 'PN', englishName: 'Pitcairn' },
  { id: 'PR', englishName: 'Puerto Rico' },
  { id: 'PS', englishName: 'Palestine, State of' },
  { id: 'PT', englishName: 'Portugal' },
  { id: 'PW', englishName: 'Palau' },
  { id: 'PY', englishName: 'Paraguay' },
  { id: 'QA', englishName: 'Qatar' },
  { id: 'RE', englishName: 'Réunion' },
  { id: 'RO', englishName: 'Romania' },
  { id: 'RS', englishName: 'Serbia' },
  { id: 'RU', englishName: 'Russian Federation' },
  { id: 'RW', englishName: 'Rwanda' },
  { id: 'SA', englishName: 'Saudi Arabia' },
  { id: 'SB', englishName: 'Solomon Islands' },
  { id: 'SC', englishName: 'Seychelles' },
  { id: 'SD', englishName: 'Sudan' },
  { id: 'SE', englishName: 'Sweden' },
  { id: 'SG', englishName: 'Singapore' },
  { id: 'SH', englishName: 'Saint Helena, Ascension and Tristan da Cunha' },
  { id: 'SI', englishName: 'Slovenia' },
  { id: 'SK', englishName: 'Slovakia' },
  { id: 'SL', englishName: 'Sierra Leone' },
  { id: 'SM', englishName: 'San Marino' },
  { id: 'SN', englishName: 'Senegal' },
  { id: 'SO', englishName: 'Somalia' },
  { id: 'SR', englishName: 'Suriname' },
  { id: 'ST', englishName: 'Sao Tome and Principe' },
  { id: 'SV', englishName: 'El Salvador' },
  { id: 'SX', englishName: 'Sint Maarten (Dutch part)' },
  { id: 'SY', englishName: 'Syrian Arab Republic' },
  { id: 'SZ', englishName: 'Eswatini' },
  { id: 'TC', englishName: 'Turks and Caicos Islands' },
  { id: 'TD', englishName: 'Chad' },
  { id: 'TG', englishName: 'Togo' },
  { id: 'TH', englishName: 'Thailand' },
  { id: 'TJ', englishName: 'Tajikistan' },
  { id: 'TK', englishName: 'Tokelau' },
  { id: 'TL', englishName: 'Timor-Leste' },
  { id: 'TM', englishName: 'Turkmenistan' },
  { id: 'TN', englishName: 'Tunisia' },
  { id: 'TO', englishName: 'Tonga' },
  { id: 'TR', englishName: 'Türkiye' },
  { id: 'TT', englishName: 'Trinidad and Tobago' },
  { id: 'TV', englishName: 'Tuvalu' },
  { id: 'TW', englishName: 'Taiwan, Province of China' },
  { id: 'TZ', englishName: 'Tanzania, United Republic of' },
  { id: 'UA', englishName: 'Ukraine' },
  { id: 'UG', englishName: 'Uganda' },
  { id: 'US', englishName: 'United States of America' },
  { id: 'UY', englishName: 'Uruguay' },
  { id: 'UZ', englishName: 'Uzbekistan' },
  { id: 'VA', englishName: 'Holy See' },
  { id: 'VC', englishName: 'Saint Vincent and the Grenadines' },
  { id: 'VE', englishName: 'Venezuela, Bolivarian Republic of' },
  { id: 'VG', englishName: 'Virgin Islands (British)' },
  { id: 'VI', englishName: 'Virgin Islands (U.S.)' },
  { id: 'VN', englishName: 'Viet Nam' },
  { id: 'VU', englishName: 'Vanuatu' },
  { id: 'WF', englishName: 'Wallis and Futuna' },
  { id: 'WS', englishName: 'Samoa' },
  { id: 'YE', englishName: 'Yemen' },
  { id: 'YT', englishName: 'Mayotte' },
  { id: 'ZA', englishName: 'South Africa' },
  { id: 'ZM', englishName: 'Zambia' },
  { id: 'ZW', englishName: 'Zimbabwe' },
]);

export const COUNTRIES_BY_ID: Readonly<Record<string, Country>> = Object.freeze(
  UKRPOSHTA_COUNTRIES.reduce<Record<string, Country>>((accumulator, country) => {
    accumulator[country.id] = country;
    return accumulator;
  }, {}),
);
